import { base, createApiURL } from '../../lib-api/services/base';
import { ajaxRetry } from '../../lib-api/ajaxRetry';

export type ExpenseCheckResponse = {
  id: string;
  externalReference: string;
};

export type CreateExpenseCheckPayload = {
  externalReference?: string;
};

export const createExpenseCheck = ({ externalReference }: CreateExpenseCheckPayload) => {
  return ajaxRetry<ExpenseCheckResponse>({
    data: JSON.stringify({ externalReference }),
    headers: base.headers(),
    method: 'POST',
    url: createApiURL('/risk/v1/expense-checks'),
  });
};
